import { Box, Button, Center, Checkbox, Divider, ModalBody, ModalCloseButton, ModalFooter, ModalHeader, Spinner, Text } from "@chakra-ui/react";
import CustomTable, { Column } from "../../../../components/CustomTable/customTable";

const ManagementTeamMembersModal = ({ setSelectedUniqueMembers, uniqueMembers, selectedUniqueMembers, toggleUniqueMember, mailLoading, sendMailApi }: any) => {
    return (
        <Box>
            <ModalHeader className="font-poppins text_2xl text_medium" textAlign="center"> Unique Team Members ({uniqueMembers.length}) </ModalHeader>
            <ModalCloseButton />
            <Divider />
            <ModalBody maxH="600px" overflowY="auto">
                <CustomTable value={uniqueMembers}>
                    <Column
                        header={
                            <Checkbox
                                colorScheme="green"
                                isChecked={
                                    uniqueMembers.length > 0 &&
                                    selectedUniqueMembers.length === uniqueMembers.length
                                }
                                isIndeterminate={
                                    selectedUniqueMembers.length > 0 &&
                                    selectedUniqueMembers.length < uniqueMembers.length
                                }
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setSelectedUniqueMembers(uniqueMembers);
                                    } else {
                                        setSelectedUniqueMembers([]);
                                    }
                                }}
                            />
                        }
                        body={(row: any) => (
                            <Checkbox
                                colorScheme="green"
                                isChecked={selectedUniqueMembers.some((x: any) => (x.employeeId ?? x.id) === (row.employeeId ?? row.id))}
                                onChange={() => toggleUniqueMember(row)}
                            />
                        )}
                    />

                    <Column
                        header="S.No"
                        body={(_: any, index: number) => (
                            <Text>{index + 1}</Text>
                        )}
                    />
                    <Column header="Employee ID" body={(row: any) => (
                        <Text>{row.employeeId ?? row.id}</Text>
                    )}
                    />
                    <Column field="emp_Name" header="Name" />
                    <Column field="email" header="Email" />
                    <Column header="TL / TM Name" field="tlTmName" />
                    <Column header="Role" field="tlTmRole" />
                </CustomTable>
                {mailLoading && (
                    <Center position="absolute" top={0} left={0} right={0} bottom={0} bg="rgba(255,255,255,0.6)" zIndex={10} >
                        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="green.500" size="xl" />
                    </Center>
                )}

            </ModalBody>
            <ModalFooter>
                <Button colorScheme="green" mt={4} onClick={sendMailApi} isLoading={mailLoading} loadingText="Sending..." spinnerPlacement="start" isDisabled={mailLoading}>
                    Send Mail
                </Button>
            </ModalFooter>
        </Box>
    )
}

export default ManagementTeamMembersModal